import { IUserState, useUserStore } from "@entities/user";
import { handleBeforeInstallPrompt, InstallPwaModal, registerBeforeInstallPrompt, usePwaStore } from "@features/pwa";
import { isInStandaloneMode } from "@shared/hooks";
import { registerServiceWorker } from "@shared/libs/serviceWorker";
import { FC, Fragment, PropsWithChildren, useEffect, useState } from "react";

const MODAL_SHOW_MS = 2 * 60 * 1000;

export const PwaProvider: FC<PropsWithChildren> = (props) => {
  const { children } = props;

  const isPwaMode = isInStandaloneMode();
  const user = useUserStore((state: IUserState) => state.user);
  const isAuth = Boolean(user?.id);
  const [isOpenInstallModal, setIsOpenInstallModal] = useState(false);

  const handleCloseInstallModal = () => {
    setIsOpenInstallModal(false);
  };

  useEffect(() => {
    registerServiceWorker();
    registerBeforeInstallPrompt(handleBeforeInstallPrompt);

    if (!isAuth || isPwaMode) {
      return;
    }

    const showModalTimer = setTimeout(() => {
      const deferredPrompt = usePwaStore.getState().deferredPrompt;
      const isPwaInstalled = localStorage.getItem("is-pwa-installed");

      if (deferredPrompt && !isPwaInstalled) {
        setIsOpenInstallModal(true);
      }
    }, MODAL_SHOW_MS);

    return () => clearTimeout(showModalTimer);
  }, [isAuth]);

  return (
    <Fragment>
      {children}
      <InstallPwaModal isOpen={isOpenInstallModal} onClose={handleCloseInstallModal} />
    </Fragment>
  );
};